import axios from "axios";
import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import "../../sass/shortcode/Signinup.scss";
import { BASE_URL } from "../../helpers/api";

export default function ResetPassword() {
  pageTitle("Reset Password");

  const [searchParams]            = useSearchParams();
  const navigate                  = useNavigate();
  const token                     = searchParams.get("token");

  const [password, setPassword]   = useState("");
  const [confirm, setConfirm]     = useState("");
  const [loading, setLoading]     = useState(false);
  const [message, setMessage]     = useState(null);
  const [success, setSuccess]     = useState(false);
  const [showPassword, setShowPassword]   = useState(false);
  const [showConfirm, setShowConfirm]     = useState(false);

  // Redirect if no token
  useEffect(() => {
    if (!token) {
      navigate("/forgot-password");
    }
  }, [token]);

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (password !== confirm) {
      setMessage({ type: "error", text: "Passwords do not match." });
      return;
    }

    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/.test(password)) {
      setMessage({ type: "error", text: "Password must be 8+ chars with uppercase, lowercase, number and special character (@$!%*?&)." });
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${BASE_URL}/auth/reset-password`,
        { token, password },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.success) {
        setSuccess(true);
        setTimeout(() => navigate("/signIn"), 3000);
      } else {
        setMessage({ type: "error", text: res.data.message });
      }
    } catch (err) {
      setMessage({ type: "error", text: "Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        title="Reset Password"
        subTitle="Set your new password below"
      />

      <div className="signin-container">
        <div className="signin-wrapper">
          <div className="signin-left">
            <img
              src="/images/auth-img.png"
              alt="Reset Password"
              className="signin-image"
            />
          </div>

          <div className="signin-form">
            {success ? (
              // ✅ Success Screen
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <div style={{ fontSize: "60px", marginBottom: "16px" }}>🎉</div>
                <h2 className="signin-title">Password Reset!</h2>
                <p className="signin-subtitle">
                  Your password has been updated successfully.
                  <br />Redirecting to Sign In in 3 seconds...
                </p>
                <div className="signup-link" style={{ marginTop: "24px" }}>
                  <Link to="/signIn">Go to Sign In →</Link>
                </div>
              </div>
            ) : (
              <>
                <h2 className="signin-title">Set New Password</h2>
                <p className="signin-subtitle">
                  Choose a strong password for your account
                </p>

                {message && (
                  <div style={{
                    padding: "10px 14px",
                    borderRadius: "6px",
                    marginBottom: "16px",
                    fontSize: "14px",
                    backgroundColor: message.type === "error" ? "#fff0f0" : "#f0fff4",
                    color: message.type === "error" ? "#cc0000" : "#1a7a3c",
                    border: `1px solid ${message.type === "error" ? "#ffcccc" : "#b2f0c8"}`,
                  }}>
                    {message.type === "error" ? "❌ " : "✅ "}{message.text}
                  </div>
                )}

                <form onSubmit={handleReset}>
                  <div className="form-group">
                    <label>New Password</label>
                    <div style={{ position: "relative" }}>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-input"
                        placeholder="Enter new password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={loading}
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute", right: "12px", top: "50%",
                          transform: "translateY(-50%)", cursor: "pointer",
                          fontSize: "18px"
                        }}
                      >
                        {showPassword ? "🙈" : "👁️"}
                      </span>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Confirm Password</label>
                    <div style={{ position: "relative" }}>
                      <input
                        type={showConfirm ? "text" : "password"}
                        className="form-input"
                        placeholder="Confirm new password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                        disabled={loading}
                      />
                      <span
                        onClick={() => setShowConfirm(!showConfirm)}
                        style={{
                          position: "absolute", right: "12px", top: "50%",
                          transform: "translateY(-50%)", cursor: "pointer",
                          fontSize: "18px"
                        }}
                      >
                        {showConfirm ? "🙈" : "👁️"}
                      </span>
                    </div>
                  </div>

                  <button type="submit" className="submit-button" disabled={loading}>
                    {loading ? "Resetting..." : "Reset Password"}
                  </button>
                </form>

                <div className="signup-link" style={{ marginTop: "16px" }}>
                  <Link to="/signIn">← Back to Sign In</Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}